// Leave empty when the API is served on the same domain, or set
// REACT_APP_API_BASE_URL (for example, https://api.evluxe.in) at build time.
export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

// Firebase's web API key is a public project identifier, not a secret. Editor
// access is enforced by Firebase Authentication and Realtime Database rules.
export const FIREBASE_API_KEY = "AIzaSyB5xck3xADuA6MZbS4QzNNHaD8sVReKx2A";
export const FIREBASE_DATABASE_URL =
  "https://evluxe-default-rtdb.asia-southeast1.firebasedatabase.app";
export const EDITOR_EMAIL = "editor@evluxe.in";

// Primary WhatsApp / phone (from evluxe.in contact page)
export const WHATSAPP_NUMBER = "917064649494"; // wa.me format (country code + number)
export const PHONE_PRIMARY = "+917064649494";
export const PHONE_SECONDARY = "+919873335281";
export const EMAIL = "info@evluxe.in";
export const WEBSITE = "https://evluxe.in/";
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://evluxe.in").replace(/\/?$/, "/");

export const publicAsset = (path) =>
  `${process.env.PUBLIC_URL || ""}/${path.replace(/^\/+/, "")}`;

export const LOGO_URL = `${publicAsset("evluxe-logo.svg")}?v=20260820-original`;

export const buildWhatsAppLink = (message, number = WHATSAPP_NUMBER) =>
  `https://wa.me/${String(number).replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;
